import FocusTrap from './FocusTrap';
import forwardRef from '../utils/forwardRef';
export default forwardRef({
  name: 'FocusTrap',
  ClassComponent: FocusTrap
});